import wcs from '@/scripts/libs/wcs'
import axios from 'axios'
import { SHOPCART_DISPLAY_VIEW } from '@/scripts/constants/pages'

const { catalogId, langId, storeId } = wcs.getStoreConfig()
const commonParameters = {
  catalogId: catalogId,
  isCalculateViewRequired: true,
  langId: langId,
  storeId: storeId,
}

class WCSEyewearProtection {
  fetchEyewearProtectionAvailability = async (orderId: string): Promise<any> => {
    const endpoint = wcs.getEndPoint('eyewearProtection')
    const params = {
      orderId: orderId,
    }

    const response = await axios.get(endpoint, {
      params: params,
    })

    const availability = response?.data?.epp
    return availability
  }

  addEyewearProtectionProduct = async ({
    eyewearProtectionCatEntryId = '',
    orderId = '',
    orderItemId = '',
    quantity = 1,
  }) => {
    const endpoint = wcs.getEndPoint('addToCart')
    const params = {
      ...commonParameters,
      calculateOrder: '1',
      calculationUsage: '-1,-3,-2,-4,-7',
      catEntryId: eyewearProtectionCatEntryId,
      eppReference: orderItemId,
      field1: 0,
      orderId: orderId,
      pageName: '',
      pgName: '',
      quantity: quantity,
      URL: SHOPCART_DISPLAY_VIEW,
    }
    const response = await axios.get(endpoint, {
      params: params,
    })

    return response
  }

  removeEyewearProtectionProduct = async ({ orderId = '', orderItemId = '' }) => {
    const endpoint = wcs.getEndPoint('removeToCart')
    const params = {
      ...commonParameters,
      doInventory: 'N',
      isDeleteFromCart: true,
      orderId,
      orderItemId,
      quantity: 0,
    }
    const response = await axios.get(endpoint, {
      params: params,
    })

    return response
  }

  updateOrderSummaryInDesktop = (orderItemUpdateResponse: HTMLElement) => {
    if (!window.reinitializeOrderSummaryAfterAjaxOrderItemUpdate) {
      return
    }

    window.reinitializeOrderSummaryAfterAjaxOrderItemUpdate(orderItemUpdateResponse)
  }

  updateOrderSummaryInMobile = async () => {
    if (!window.performOrderDetailsJsonResponse) {
      return
    }

    await window.performOrderDetailsJsonResponse()
  }

  fetchAddCopay = async (orderId = '') => {
    const endpoint = wcs.getEndPoint('addCopay')
    const endpointWithRequestParameters = `${endpoint}?orderId=${orderId}`

    try {
      await axios.post(endpointWithRequestParameters, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
    } catch (error) {
      console.error('error fetching add copay: ', error)
    }
  }
}

export default new WCSEyewearProtection()
